module.exports = __webpack_public_path__ + "static/media/liveFeedmax.bf3b7c56.svg";